import { yupResolver } from '@hookform/resolvers/yup';
import { Container } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CollectionActionBlock from 'commons/Collection/CollectionActionBlock';
import CollectionDetailBlock from 'commons/Collection/CollectionDetailBlock';
import API from 'configs/API';
import GridLayout from 'layouts/GridLayout';
import Routes from 'utils/Route';
import { axiosPost } from 'utils/apis/axios';
import { ToastTopHelper } from 'utils/utils';

import useStyles from './styles';
import { collectionSchema } from './validates/collectionSchema';

const CreateCollection = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.account.user);
  const navigate = useNavigate();

  const collectionFormState = useForm({
    values: {
      isCollectionVisible: true,
    },
    mode: 'onChange',
    resolver: yupResolver(collectionSchema),
  });

  const { formState, setValue } = collectionFormState;

  const handleCreateCollection = async (data) => {
    const formData = {
      title: data.title,
      description: data.description,
      owner: user.id,
      is_public: true,
      artworks: data.addedArtworks,
    };

    const { success } = await axiosPost(API.ARTWORK.COLLECTION, formData);
    if (success) {
      ToastTopHelper.success(t('collection_created_successfully'));
      navigate(Routes.GalleryDetail(user?.uuid));
    }
  };

  return (
    <div className={classes.wrapper}>
      <Container>
        <GridLayout>
          <CollectionActionBlock
            title={t('create_collection')}
            formState={formState}
            setValue={setValue}
          />
          <CollectionDetailBlock
            textButtonRight={t('create_collection')}
            collectionFormState={collectionFormState}
            handleSubmitCollection={handleCreateCollection}
          />
        </GridLayout>
      </Container>
    </div>
  );
};

export default CreateCollection;
